export const NAV_DROPDOWN_PANEL_PROPS = {
	elevation: 0,
	paperStyle: { borderRadius: 12, boxShadow: "0px 0px 8px var(--shadow-1)" },
};
